<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="inline-oil">
    <!-- <h5>油卡余额不足</h5> -->
    <table class="dataintable">

      <tr class="tab_header">
        <td>序号</td>
        <td class="short0 left">客户姓名</td>
        <td class="short0 left">客户电话</td>
        <td class="short0 left">客户车牌</td>
		<td class="short0 left">停车场</td>
        <td class="short0">实际入场</td>
        <td class="short0">实际出场</td>
        <td class="short0">计划包月</td>
        <td class="short0">类型</td>
        <td class="short0">剩余天数</td>
        <!-- <td class="short0">应收金额</td> -->
        <td class="short0">实收金额</td>
        <td class="short0">未收金额</td>
        <td class="short0">优惠金额</td>
        <td>操作</td>
      </tr>
      <tr v-for="(item, index) in list_carpark" :key="index">
        <td>{{ item.row_num }}</td>
        <td class="short0 left">{{ item.cus_name }}</td>
        <td class="short0 left">{{item.cus_phone}}</td>
        <td class="short0 left">{{item.car_no}}</td>
		<td class="short0 left">{{item.park_name}}</td>
        <td class="short0">{{ item.indate }}</td>
        <td class="short0">{{ item.outdate }}</td>
        <td class="short0">{{ item.buydate }}</td>
        <td class="short0">{{ item.cusclass }}</td>
        <td class="short0">{{ item.lastday }}</td>
        <!-- <td class="short0">{{ item.amount }}</td> -->
        <td class="short0">{{ item.amount_in }}</td>
        <td class="short0">{{ item.amount_no }}</td>
        <td class="short0">{{ item.amount_dis }}</td>
        <td><span class="hulue-btn" v-show="item.tx_flag=='1'" @click="fun_isNot(item)">忽略</span></td>
      </tr>
    </table>
  </div>
</template>

<script>
  import api from '@/utils/type.js'

  import {
    Sel_page_and_length,
    Method_EasyAdd
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "oil",
    data() {
      return {
        element_loading: false,

        list_carpark: []



      };
    },
    // created: function() {
    //   console.log('油卡 组件 创建');
    //   // this.loaddata();
    // },
    mounted: function() {
      // console.log('包月 组件 mounted');
      this.loaddata();
    },
    // activated: function() {
    //   console.log('油卡 组件激活时调用 激活');

    // },
    methods: {
      loaddata: function() {
        this.element_loading = true;
        this.list_carpark = [];

        let r = (Math.random() + '').substring(0, 8);

        this.$post(
          api.http_method, Sel_page_and_length('exp_carpark', 1, 100)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          if (res.length > 0) {
            // console.log(res[0]);
            let t = res[0];
            for (let i = 0; i < t.length; i++) {
              let o = {};

              o = t[i];
              o.row_num = i + 1;
              this.list_carpark.push(o);
            }
          }

          // console.log(this.list_carpark);

        });
      },
      fun_isNot: function(item) {
        console.log(item);
        this.element_loading = true;

        this.$post(
          api.http_method, Method_EasyAdd('data_exp_carpark',item.id)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: item.cus_name+':'+res.data.msg,
              type: 'success'
            });

            this.loaddata();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });


      }
    }


  }
</script>

<style scoped="scoped">
  .inline-oil {
    display: inline-block;
    min-height: calc(100vh - 120px);
    max-height: calc(100vh - 120px);
    overflow: auto;
    vertical-align: top;
  }

  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }

  .hulue-btn {
    display: inline-block;
    /* border: 1px solid black; */
    border-radius: 5px;
    background: #ff5500;
    text-align: center;
    padding: 2px 2px 2px 2px;
    /* font-size: 16px; */
    margin-left: 2px;
    margin-right: 2px;
  }

  .hulue-btn:hover {
    cursor: pointer;
    background-color: rgba(247, 61, 36, 0.986);
    /* font-size: 16px; */
  }
</style>
